/**
 * Consistent empty/null value display for table cells.
 * Renders a muted dash to indicate no data.
 */
export function EmptyValue() {
  return <span className="text-muted-foreground">-</span>
}
